import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-GDesign";
import leftimgs from "../../../assets/1 (11).png";
import rightimgs from "../../../assets/1 (12).png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/figma-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/figma-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/figma-benefit-img3.png";
import BenefitsDataImg4 from "../../../assets/figma-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/figma-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/figma-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/figma-benefit-img7.png";
import BenefitsDataImg8 from "../../../assets/figma-benefit-img8.png";
import BenefitsDataImg9 from "../../../assets/figma-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/figmaFun-img1.png";
import FunactivitiesImg2 from "../../../assets/figmaFun-img2.png";
import FunactivitiesImg3 from "../../../assets/figmaFun-img3.png";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";

import LearningStyle from "../../../MyComponents/LearningStyle"
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "06",
      classes: "03",
      description:" Figma Fundamentals Learn Figma basics—shapes, text, and UI design principles. Create icons, buttons, and simple layouts.",
    },
    {
      title: "Module 2",
      activities: "06",
      classes: "02",
      description:"App Design & Prototyping- Design full mobile app interfaces with user flows and interactive prototypes that look great and work well.",
    },
    {
      title: "Module 3",
      activities: "06",
      classes: "01",
      description:" Website Design -Build responsive desktop and mobile websites. Final project: design a complete educational site.",
    },
];    

  const benefitsData = [
      {
        title: "UI/UX Fundamentals",
        description: "Learn design basics and user flow.",
        icon: "Polymath-images/figma-benefit-img1.png",
      },
      {
        title: "Design Principles",
        description: "Layout, color, and typography.",
        icon: "Polymath-images/figma-benefit-img2.png",
      },
      {
        title: "Figma  Basics",
        description: "Learn to use Figma’s full toolkit to bring your ideas to life.",
        icon: "Polymath-images/figma-benefit-img3.png",
      },
      {
        title: "Advanced Figma Design",
        description: "Prototyping and components",
        icon: "Polymath-images/figma-benefit-img4.png",
      },
      {
        title: "Figma Assets & Animations",
        description: "Libraries and transitions",
        icon: "Polymath-images/figma-benefit-img5.png",
      },
      {
        title: "Build  Prototyping",
        description: "Turn your static designs into clickable, real-world simulations.",
        icon: "Polymath-images/figma-benefit-img6.png",
      },
      {
        title: "Design a Pro Portfolio",
        description: "Highlight your best work to attract clients and job offers.",
        icon: "Polymath-images/figma-benefit-img7.png",
      },
      {
        title: "Website Design",
        description: "Responsive layouts and wireframes.",
        icon: "Polymath-images/figma-benefit-img8.png",
      },
      {
        title: "Mobile App Design",
        description: "App UI and user experience",
        icon: "Polymath-images/figma-benefit-img9.png",
      },
    ];
    const activitiesData = [
        {
          title: "Mobile App Design",
          image: "Polymath-images/figmaFun-img1.png",
        },
        {
          title: "Website Layout",
          image: "Polymath-images/figmaFun-img2.png",
        },
        {
          title: "Game Interface ",
          image: "Polymath-images/figmaFun-img3.png",
        }
       
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "https://www.youtube.com/embed/p4pilMiPITE",
  };
const Figma = () => {
  const Figmapage = heroContent.figmasection;
  return (
    <>
       {/* <GuestNav/> */}
      <HeadSection
      leftImg={"Polymath-images/1 (11).png"}
      rightImg={"Polymath-images/1 (12).png"}
      titlePart1="UI/UX Design with Figma"
      titlePart2="Course"
      description="Discover the exciting world of digital design! Our Figma course teaches kids the fundamentals of UI/UX design, from creating simple icons to designing complete apps and websites. Perfect for creative minds, this course develops visual design and prototyping skills through hands-on projects."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={"Polymath-images/pencil.png"}
      button2Icon={"Polymath-images/pencil.png"}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
        title="Course Structure and Syllabus"
        modules={beginnerModules}
      />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Corel Draw"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default Figma